import { useEffect, useState } from "react";

const useKeyboardOpen = () => {
    const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const isVisible = window.visualViewport
                ? window.visualViewport.height < window.innerHeight * 0.7
                : window.innerHeight < window.outerHeight * 0.7;

            setIsKeyboardOpen(isVisible);
        };

        const handleFocusIn = () => {
            setTimeout(handleResize, 100); // wait for keyboard animation
        };

        const handleFocusOut = () => {
            setTimeout(() => setIsKeyboardOpen(false), 100);
        };

        if (window.visualViewport) {
            window.visualViewport.addEventListener("resize", handleResize);
        } else {
            window.addEventListener("resize", handleResize);
        }

        window.addEventListener("focusin", handleFocusIn);
        window.addEventListener("focusout", handleFocusOut);

        // initial check
        handleResize();

        return () => {
            if (window.visualViewport) {
                window.visualViewport.removeEventListener("resize", handleResize);
            } else {
                window.removeEventListener("resize", handleResize);
            }
            window.removeEventListener("focusin", handleFocusIn);
            window.removeEventListener("focusout", handleFocusOut);
        };
    }, []);

    return isKeyboardOpen;
};

export default useKeyboardOpen;